import { useState } from 'react';
import { Modal, StyleSheet, View } from 'react-native';
import PanelHelp from '../screens/PanelHelp.js';
import PanelInfo from '../screens/PanelInfo.js';
import PanelSupport from '../screens/PanelSupport.js';
import ToolbarButton from './ToolbarButton.js';

export default function Toolbar(props) {
  const [helpVisible, setHelpVisible] = useState(false);
  const [infoVisible, setInfoVisible] = useState(false);
  const [supportVisible, setSupportVisible] = useState(false);

  const showHelp = () => setHelpVisible(true);
  const showInfo = () => setInfoVisible(true);
  const showSupport = () => setSupportVisible(true);

  const hideHelp = () => setHelpVisible(false);
  const hideInfo = () => setInfoVisible(false);
  const hideSupport = () => setSupportVisible(false);

  const styles = {
    toolbar: {
      position: 'absolute',
      opacity: 0.75,
      left: 0,
      right: 0,
      bottom: 24,
      height: 50,
      justifyContent: 'space-between',
      flexDirection: 'row',
      backgroundColor: '#777',
      paddingLeft: 20,
      paddingRight: 20,
      paddingTop: 6
    },

  };

  return (
    <>
      <View style={styles.toolbar}>
        <ToolbarButton label="?" tapped={showHelp} altTapped={showSupport} />
        {props.showClose && <ToolbarButton label="X" tapped={props.onClose} />}
        {!props.showClose && <ToolbarButton label="..." tapped={showInfo} />}
      </View>

      {/* Help Modal */}
      <Modal
        animationType="slide"
        transparent={true}
        visible={helpVisible}
        onRequestClose={hideHelp}
      >
        <View style={modalStyles.modalOverlay}>
          <View style={modalStyles.modalContainer}>
            <PanelHelp 
              {...props} 
              dismiss={hideHelp}
            />
          </View>
        </View>
      </Modal>

      {/* Info Modal */}
      <Modal
        animationType="slide"
        transparent={true}
        visible={infoVisible}
        onRequestClose={hideInfo}
      >
        <View style={modalStyles.modalOverlay}>
          <View style={modalStyles.modalContainer}>
            <PanelInfo 
              {...props} 
              dismiss={hideInfo}
            />
          </View>
        </View>
      </Modal>

      {/* Support Modal */}
      <Modal
        animationType="slide"
        transparent={true}
        visible={supportVisible}
        onRequestClose={hideSupport}
      >
        <View style={modalStyles.modalOverlay}>
          <View style={modalStyles.modalContainer}>
            <PanelSupport 
              {...props} 
              dismiss={hideSupport}
            />
          </View>
        </View>
      </Modal>
    </>
  );
}

const modalStyles = StyleSheet.create({
  modalOverlay: {
    flex: 1,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    justifyContent: 'center',
    alignItems: 'center',
  },
  modalContainer: {
    backgroundColor: 'white',
    borderRadius: 10,
    padding: 20,
    margin: 20,
    maxHeight: '80%',
    maxWidth: '90%',
    minWidth: '80%',
  },
});
